import React from 'react'
import { NavLink } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import Sub from './assets/subArr.png'
import Max from './assets/Max.png'
import fnd from './assets/fnd.jpg'
import Paren from './assets/paren.png'
import Jump from './assets/jump.png'
import Same from './assets/same.png'
import Count from './assets/count.jfif'
import Lru from './assets/LRU.png'
import Inter from './assets/interleave.png'
import Zero from './assets/0.jpg'
import Egg from './assets/egg.jpg'
import Word from './assets/word.jpg'
import Bin from './assets/bin.jpg'
import Mod from './assets/mod.jpg'
const Google = () => {
    return (
        <div>
                 <div class="cards-list" data-aos="fade-down" data-aos-delay="100">
  
  <div class="card 1">
    <div class="card_image"> <img src={Sub}/> </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1rem'}}>Subarray with given sum</p>
      <NavLink to='/category/Google Interview question 1'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
    <div class="card 2">
    <div class="card_image">
      
      <img src={Max} />
      </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1rem'}}>Maximum Index</p>
      <NavLink to='/category/Google Interview question 2'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
  <div class="card 1">
    <div class="card_image">
      <img src={fnd} />
    </div>
    <div class="card_title">
        <p style={{fontSize:'1rem'}}>Finding the numbers</p>
        <NavLink to='/category/Google Interview question 3'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
    <div class="card 2">
    <div class="card_image">
      <img src={Paren} />
      </div>
    <div class="card_title title-black">
      <p style={{fontSize:'1rem'}}>Longest valid Parentheses</p>
      <NavLink to='/category/Google Interview question 4'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
    </div>
   
    </div>
          <div class="cards-list"data-aos="fade-down" data-aos-delay="100">
    
  <div class="card 3">
    <div class="card_image"> <img src={Jump} /> </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1rem'}}>Jumping Numbers</p>
      <NavLink to='/category/Google Interview question 5'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
    <div class="card 4">
    <div class="card_image">
      <img src={Same} />
      </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1rem'}}>Connect Nodes at Same Level</p>
      <NavLink to='/category/Google Interview question 6'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
  <div class="card 3">
    <div class="card_image">
      <img src={Count} />
    </div>
    <div class="card_title">
        <p style={{fontSize:'1rem'}}>Count BST nodes that lie in a given range</p>
        <NavLink to='/category/Google Interview question 7'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
    <div class="card 4">
    <div class="card_image">
      <img src={Lru} />
      </div>
    <div class="card_title title-black">
      <p style={{fontSize:'1rem'}}>Implement LRU Cache</p>
      <NavLink to='/category/Google Interview question 8'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
    </div>
   
    </div>
          <div class="cards-list"data-aos="fade-down" data-aos-delay="100">
    
  <div class="card 3">
    <div class="card_image"> <img src={Inter} /> </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1rem'}}>Interleaved Strings</p>
      <NavLink to='/category/Google Interview question 9'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
    <div class="card 4">
    <div class="card_image">
      <img src={Zero} />
      </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1rem'}}>Find triplets with zero sum</p>
      <NavLink to='/category/Google Interview question 10'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
  <div class="card 3">
    <div class="card_image">
      <img src={Egg} />
    </div>
    <div class="card_title">
        <p style={{fontSize:'1rem'}}>Egg Dropping Puzzle</p>
        <NavLink to='/category/Google Interview question 11'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
    <div class="card 4">
    <div class="card_image">
      <img src={Word} />
      </div>
    <div class="card_title title-black">
      <p style={{fontSize:'1rem'}}>Word Break Problem</p>
      <NavLink to='/category/Google Interview question 12'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
    </div>
   
    </div>
          <div class="cards-list"data-aos="fade-down" data-aos-delay="100">
    
  <div class="card 3">
    <div class="card_image"> <img src={Bin} /> </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1rem'}}>Check if a Binary Tree contains duplicate subtrees of size 2 or more</p>
      <NavLink to='/category/Google Interview question 13'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
    <div class="card 4">
    <div class="card_image">
      <img src={fnd} />
      </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1rem'}}>Find largest word in dictionary by deleting some characters of given string</p>
      <NavLink to='/category/Google Interview question 14'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
  <div class="card 3">
    <div class="card_image">
      <img src={Mod} />
    </div>
    <div class="card_title">
        <p style={{fontSize:'1rem'}}>Modular Exponentiation (Power in Modular Arithmetic)</p>
        <NavLink to='/category/Google Interview question 15'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
  
    </div>  
        </div>
    )
}

export default Google
